import { i18n } from "@/i18n/index";
import { calc } from "@/lib/util/calc.min.js";

class LanguageContent{
    // 处理json请求后缀文件
    static getJsonSuffix() {
        switch(i18n.locale) {
            case 'zh_CN':
                return 'CN'
            case 'en':
                return 'EN'
            case 'zh_TW':
                return 'zh_TW'
            default:
                return 'EN'
        }
    }

    // 处理api请求后缀文件
    static getApiSuffix() {
        switch(i18n.locale) {
            case 'zh_CN':
                return 'zh_CN'
            case 'en':
                return 'en_US'
            case 'zh_TW':
                return 'zh_TW'
            default:
                return 'en_US'
        }
    }

    static getPaaSJsonSuffix() {
        switch(i18n.locale) {
            case 'zh_CN':
                return 'zh'
            case 'zh_TW':
                return 'cht'
            case 'en':
                return 'en'
            case 'ru':
                return 'ru'
            case 'bel':
                return 'bel'
            case 'fra':
                return 'fra'
            case 'de':
                return 'de'
            case 'it':
                return 'it'
            case 'pl':
                return 'pl'
            case 'pt':
                return 'pt'
            case 'spa':
                return 'spa'
            case 'jp':
                return 'jp'
            case 'kor':
                return 'kor'
            case 'ara':
                return 'ara'
            case 'hi':
                return 'hi'
            case 'ben':
                return 'ben'
            case 'id':
                return 'id'
            default: 
                return 'en'
        }
    }

    static getI18nLocaleByPaaSJsonSuffix(code){
        switch(code) {
            case 'zh':
                return 'zh_CN'
            case 'cht':
                return 'zh_TW'
            case 'en':
                return 'en'
            case 'ru':
                return 'ru'
            case 'bel':
                return 'bel'
            case 'fra':
                return 'fra'
            case 'de':
                return 'de'
            case 'it':
                return 'it'
            case 'pl':
                return 'pl'
            case 'pt':
                return 'pt'
            case 'spa':
                return 'spa'
            case 'jp':
                return 'jp'
            case 'kor':
                return 'kor'
            case 'ara':
                return 'ara'
            case 'hi':
                return 'hi'
            case 'ben':
                return 'ben'
            case 'id':
                return 'id'
        }
    }

    static getLangCodeByBrowser(){
        const browserLangCode = navigator.language || navigator.userLanguage
        switch(browserLangCode) {
            case 'zh-CN':
                return 'zh'
            case 'zh-TW':
                return 'cht'
            case 'en':
                return 'en'
            case 'ru':
                return 'ru'
            case 'be':
                return 'bel'
            case 'fr-FR':
                return 'fra'
            case 'de':
                return 'de'
            case 'it':
                return 'it'
            case 'pl':
                return 'pl'
            case 'pt':
                return 'pt'
            case 'es':
                return 'spa'
            case 'ja':
                return 'jp'
            case 'ko':
                return 'kor'
            case 'ar':
                return 'ara'
            case 'hi':
                return 'hi'
            case 'bn':
                return 'ben'
            case 'id':
                return 'id'
        }
    }

    // 价格页获取折扣
    static getDiscount(discount) {
        if(i18n.locale === 'zh_CN' || i18n.locale === 'zh_TW') {
            return calc.mul(discount, 10)
        }else {
            return calc.mul(calc.sub(1, discount), 100)
        }
    }
}

export { LanguageContent }


// WEBPACK FOOTER //
// ./src/lib/util/lang.js